<template>
    <!--弹窗-->
    <el-dialog width="500px" :title="title" :visible.sync="visible" :before-close="handleClose">
        <el-form ref="formData" :model="formData">
            <el-form-item>
                <el-input
                    v-model="str"
                    :rows="7"
                    type="textarea"
                    style="width: 460px;"
                    placeholder="输入竞品ASIN，已换行区分"
                >
                </el-input>
            </el-form-item>
        </el-form>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose(true)"
            >取 消</el-button>
            <el-button style="float:right" size="mini" type="primary" @click="submitForm('formData')" :loading="loading">确定</el-button>
        </el-row>
    </el-dialog>
</template>
<script>
import * as api from "@/api/Product/Product";
export default {
    data() {
        return {
            loading: false,
            str: ""
        };
    },
    props: {
        formData: {
            type: Object,
            default: () => {}
        },
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        }
    },
    methods: {
        // 同步竞品数据
        asin_str(str) {
            this.str = str;
        },
        // 保存信息
        submitForm() {
            let snsArr = [];
            snsArr = this.str.split(/[(\r\n)\r\n]+/);
            snsArr.forEach((item, index) => {
                if (!item) {
                    snsArr.splice(index, 1); //删除空项
                }
            });
            if (snsArr.length > 5) {
                return this.$message({
                    type: "error",
                    message: "最多可输入5个竞品ASIN"
                });
            }
            this.loading = true;
            api.competitors({ id: this.formData.id, competitors: snsArr })
                .then(res => {
                    this.loading = false;
                    if (res.code === 0) {
                        this.$message({
                            message: "修改竞品成功",
                            type: "success"
                        });
                        this.handleClose(false);
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                    this.$message({
                        type: "error",
                        message: "网络出现问题，请刷新页面！"
                    });
                });
        },
        // 关闭弹窗
        handleClose(isshow) {
            this.arr = "";
            this.$refs["formData"].resetFields();
            this.loading = false;
            this.$emit("close-callback", isshow, this.formData);
        }
    }
};
</script>
<style type="text/scss" lang="scss" scoped>
/deep/ ::-webkit-scrollbar {
    width: 7px;
    height: 5px;
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
/deep/ ::-webkit-scrollbar-track-piece {
    background-color: #ffff;
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
/deep/ ::-webkit-scrollbar-thumb:vertical {
    height: 5px;
    background-color: rgba(144, 147, 153, 0.5);
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
/deep/ ::-webkit-scrollbar-thumb:horizontal {
    width: 7px;
    background-color: rgba(144, 147, 153, 0.5);
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
</style>
